"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MlcUsageStaticsContainerComponent = MlcUsageStaticsContainerComponent;
const Elements = __importStar(require("@genesys/client-core/lib/elements"));
const GraphQLQuery = __importStar(require("@genesys/client-core/lib/graphql-query"));
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const React = __importStar(require("react"));
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
const Actions = __importStar(require("./actions"));
const container_1 = require("./result/container");
const search_inputs_component_1 = require("./search-inputs-component");
const queryProduct = (0, graphql_tag_1.default) `
  query MlcUsageStatisticsContainerComponentProduct {
    product {
      mlcStatus {
        id
        statusName
      }
      genesysNumberPrefixes {
        id
        genesysNo
        moistureLoadNo
      }
    }
  }
`;
function MlcUsageStaticsContainerComponent(props) {
    return (React.createElement(GraphQLQuery.QueryProductSimple, { query: queryProduct, variables: {} }, ({ product: { mlcStatus, genesysNumberPrefixes } }) => {
        const { searchOptionsStates } = props;
        return (React.createElement(Elements.ScrollContainer, null,
            React.createElement(Elements.FlexContainerRowWithPadding, null,
                React.createElement(Elements.H2, null, "MLC Usage statistics")),
            React.createElement(search_inputs_component_1.SearchInputsComponent, { includeMno: props.includeMno, toogleMNo: () => props.dispatch(Actions.toggleIncludeMnoAction()), searchOptionsStates: searchOptionsStates, deletedMenuItems: [
                    {
                        name: "Active",
                        value: "0"
                    },
                    {
                        name: "Is Deleted",
                        value: "1"
                    }
                ], status: mlcStatus.map((x) => ({
                    value: x.id,
                    name: x.statusName
                })), onFilterToggle: (type) => toggleFilter(props, type, "useFilter"), onGroupByToggle: (type) => toggleFilter(props, type, "groupBy"), onUserInputChange: (val) => handleUserInputChange(props, val), onStatusChange: (e) => handleStatusChange(props, e), onDeletedChange: (e) => handleDeletedChange(props, e), startDateOnChange: (newDate) => handleDateChange(props, newDate, "startDate"), endDateOnChange: (newDate) => handleDateChange(props, newDate, "endDate") }),
            React.createElement(Elements.FlexContainerRowWithPadding, null,
                React.createElement("div", null,
                    React.createElement(Elements.StandardButton, { disabled: !isSearchable(props), onClick: () => props.dispatch(Actions.toggleSearchResultsAction()) }, "Go"))),
            React.createElement(Elements.FlexContainerRowWithPadding, null,
                React.createElement(ResultView, Object.assign({}, props, { genesysNumberPrefixes: genesysNumberPrefixes })))));
    }));
}
function ResultView(props) {
    if (!props.searchResults) {
        return null;
    }
    return (React.createElement(container_1.ResultContainer, { genesysNumberPrefixes: props.genesysNumberPrefixes, searchSelections: props.currentSearchSelections }));
}
const handleUserInputChange = (props, newUsers) => {
    const type = "users";
    const values = Array.from(props.searchOptionsStates.values());
    const filterOption = values.find((x) => x.type === type);
    const newVal = Object.assign(Object.assign({}, filterOption), { selectedUsers: newUsers });
    const filtered = values.filter((x) => x.type !== type);
    filtered.push(newVal);
    props.dispatch(Actions.setFilterOptionsState(filtered));
};
const handleStatusChange = (props, e) => {
    const type = "status";
    const values = Array.from(props.searchOptionsStates.values());
    const filterOption = values.find((x) => x.type === type);
    const newVal = Object.assign(Object.assign({}, filterOption), { selectedStatus: filterSelectedValues(e.target).map((s) => Number.parseInt(s, 10)) });
    const filtered = values.filter((x) => x.type !== type);
    filtered.push(newVal);
    props.dispatch(Actions.setFilterOptionsState(filtered));
};
const handleDeletedChange = (props, e) => {
    const type = "deleted";
    const values = Array.from(props.searchOptionsStates.values());
    const filterOption = values.find((x) => x.type === type);
    const newVal = Object.assign(Object.assign({}, filterOption), { selectedDeletedOptions: filterSelectedValues(e.target).map((s) => Number.parseInt(s, 10)) });
    const filtered = values.filter((x) => x.type !== type);
    filtered.push(newVal);
    props.dispatch(Actions.setFilterOptionsState(filtered));
};
const handleDateChange = (props, newDate, dateType) => {
    const type = "date";
    const values = Array.from(props.searchOptionsStates.values());
    const filterOption = values.find((x) => x.type === type);
    const newVal = Object.assign(Object.assign({}, filterOption), { [dateType === "startDate"
            ? "selectedStartDateStringified"
            : "selectedEndDateStringified"]: newDate });
    const filtered = values.filter((x) => x.type !== type);
    filtered.push(newVal);
    props.dispatch(Actions.setFilterOptionsState(filtered));
};
const toggleFilter = (props, type, key) => {
    const values = Array.from(props.searchOptionsStates.values());
    const filterOption = values.find((x) => x.type === type);
    const newVal = Object.assign(Object.assign({}, filterOption), { [key]: !filterOption[key] });
    const filtered = values.filter((x) => x.type !== type);
    filtered.push(newVal);
    props.dispatch(Actions.setFilterOptionsState(filtered));
};
function filterSelectedValues(selectElement) {
    return Array.from(selectElement.options)
        .filter((o) => o.selected)
        .map((o) => o.value);
}
function isSearchable(props) {
    return props.searchOptionsStates.every(filterGroupIsSearchable);
}
function filterGroupIsSearchable(searchOptionState) {
    const { type, useFilter } = searchOptionState;
    switch (type) {
        case "date": {
            return !(useFilter &&
                !(searchOptionState.selectedEndDateStringified ||
                    searchOptionState.selectedStartDateStringified));
        }
        case "deleted": {
            return !(useFilter && !(searchOptionState.selectedDeletedOptions.length > 0));
        }
        case "status": {
            return !(useFilter && !(searchOptionState.selectedStatus.length > 0));
        }
        case "users": {
            return !(useFilter && !searchOptionState.selectedUsers);
        }
        default:
            (0, ts_exhaustive_check_1.exhaustiveCheck)(type);
    }
}
//# sourceMappingURL=container-component.js.map